export default __webpack_public_path__ + "assets/north-macedonia-flag.png";